import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import ActionBar from "../shared/general/ActionBar";
import CandidatePageTabNavigation from "../TabNavigation/CandidatePageTabNavigation";
import { GlobalStyle } from "../TabNavigation/styles/router-nav-styles";
import ErrorMessage from "./ErrorMessage";
import SuccessMessage from "./SuccessMessage";
import messageType from "./types/messageType";
import otherUserType from "./types/otherUserType";
import candidateAboutType from "./types/candidateAboutType";
import CandidateProfileWrapper from "./styles/candidate-profile-styles";
import updateApplication from "../../actions/candidateProfileActions";
import { validateFileBeforeUpload } from "../../utils/chunkedUpload";

class CandidateProfile extends Component {
  constructor(props) {
    super(props);

    const {
      status: {
        last_action: lastAction,
        job_status: jobStatus,
        is_rejected: isRejected,
        interview_confirmed: interviewConfirmed,
      },
      messages,
      offer_made: offerMade,
      job_filled: jobFilled,
      cv_count: cvCount,
    } = this.props;

    this.state = {
      errors: null,
      status: { lastAction, jobStatus, isRejected, interviewConfirmed },
      messages,
      success: false,
      actionsDropdown: false,
      offerMade,
      jobFilled,
      cvCount,
      uploadProgress: 0,
      isUploading: false,
      pendingUpload: null, // Skeleton message data for pending upload
    };

    this.uploadSubscription = null;
  }

  componentWillUnmount() {
    // Clean up ActionCable subscription when component unmounts
    if (this.uploadSubscription) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }
  }

  increaseApplicationCvReadCount = () => {
    const { application_id: applicationId, is_employer: isEmployer } =
      this.props;

    this.setState(({ cvCount }) => {
      if (isEmployer) {
        updateApplication({
          applicationId,
          cvReadCount: cvCount.cv_opened_count + 1,
        });
      }

      return {
        cvCount: {
          ...cvCount,
          cv_opened_count: cvCount.cv_opened_count + 1,
        },
      };
    });
  };

  handleDownloadCv = (e) => {
    e.preventDefault();

    const {
      application_id: applicationId,
      is_employer: isEmployer,
      cv_download_path: cvDownloadPath,
    } = this.props;

    this.setState(({ cvCount }) => {
      if (isEmployer) {
        updateApplication({
          applicationId,
          cvDownloadCount: cvCount.cv_downloaded_count + 1,
        });
      }

      return {
        cvCount: {
          ...cvCount,
          cv_downloaded_count: cvCount.cv_downloaded_count + 1,
        },
      };
    });

    window.location = cvDownloadPath;
  };

  clearError = () => this.setState({ errors: null });

  clearSuccess = () => {
    this.setState({ success: false });
  };

  delayedClearError = () => {
    setTimeout(() => {
      this.clearError();
    }, 3000);
  };

  delayedClearSuccess = () => {
    setTimeout(() => {
      this.clearSuccess();
    }, 3000);
  };

  delayedClearSuccess = () => {
    setTimeout(() => {
      this.clearSuccess();
    }, 3000);
  };

  profileBodyClickHandle = () => {
    const { actionsDropdown } = this.state;
    if (actionsDropdown === true) {
      this.setState({ actionsDropdown: false });
    }
  };

  toggleActionsDropdown = () => {
    this.setState(({ actionsDropdown }) => ({
      actionsDropdown: !actionsDropdown,
    }));
  };

  scrollToBottom = () => {
    const item = document.getElementById("scroller");
    const wrapper = document.getElementById("wrapper");
    const count = item.offsetTop - wrapper.scrollTop;
    wrapper.scrollTop = count;
    wrapper.scrollLeft = 0;
  };

  updateCandidateStatus = async ({
    action,
    actionAt,
    actionEndAt,
    message,
    attachment = "",
    finalSalary,
    rejectionData = null,
  }) => {
    const { update_status_link: url } = this.props;

    if (attachment) {
      const validation = validateFileBeforeUpload(attachment);
      if (!validation.valid) {
        this.setState({ errors: { general: validation.error } });
        this.delayedClearError();
        return false;
      }
      this.setState({
        isUploading: true,
        uploadProgress: 0,
        pendingUpload: {
          id: -Date.now(),
          action,
          message,
          created_at: new Date().toLocaleString(),
          author: { first_name: "Uploading", last_name: "..." },
          isSkeleton: true,
          attachmentName: attachment.name,
        },
        messages: [...this.state.messages, {
          id: -Date.now(),
          action,
          message,
          created_at: new Date().toLocaleString(),
          author: { first_name: "Uploading", last_name: "..." },
          isSkeleton: true,
          attachmentName: attachment.name,
        }],
      });
    }

    try {
      return await this.handleRegularUpload({
        url,
        action,
        actionAt,
        actionEndAt,
        message,
        attachment,
        finalSalary,
        rejectionData,
      });
    } catch (error) {
      this.setState({
        errors: error.response?.data?.errors || { general: error.message },
        isUploading: false,
        uploadProgress: 0,
      });
      this.delayedClearError();
      return false;
    }
  };

  handleRegularUpload = async ({
    url,
    action,
    actionAt,
    actionEndAt,
    message,
    attachment,
    finalSalary,
    rejectionData,
  }) => {
    const formData = new FormData();

    formData.append("application_action[attachment]", attachment);
    formData.append("application_action[action]", action);
    formData.append("application_action[message]", message);
    formData.append("application_action[action_at]", actionAt);
    formData.append("application_action[action_end_at]", actionEndAt);
    formData.append("application_action[final_salary]", finalSalary);

    // Add rejection reason data if provided (for rejected_candidate action)
    if (rejectionData && action === "rejected_candidate") {
      formData.append(
        "application_action[application_action_rejection_reason_attributes][primary_reason_id]",
        rejectionData.primaryReasonId
      );

      rejectionData.subReasonIds.forEach((subReasonId) => {
        formData.append(
          "application_action[application_action_rejection_reason_attributes][sub_reason_ids][]",
          subReasonId
        );
      });
    }

    const axiosConfig = {
      headers: { "Content-Type": "multipart/form-data" },
    };
    if (attachment && typeof XMLHttpRequest !== "undefined") {
      axiosConfig.onUploadProgress = (e) => {
        if (e.lengthComputable) {
          this.setState({ uploadProgress: Math.round((e.loaded / e.total) * 100) });
        }
      };
    }

    const { data } = await axios.post(url, formData, axiosConfig);
    return this.handleUploadSuccess(data);
  };

  handleUploadSuccess = (data) => {
    const {
      job_status: jobStatus,
      last_action: lastAction,
      last_message: lastMessage,
      offer_made: offerMade,
      job_filled: jobFilled,
      is_rejected: isRejected,
      interview_confirmed: interviewConfirmed,
      ...restData
    } = data;
    const newMessage = { ...lastMessage, ...restData };
    this.setState(({ messages }) => ({
      status: { jobStatus, lastAction, isRejected, interviewConfirmed },
      messages: [...messages.filter((m) => !m.isSkeleton), newMessage],
      success: true,
      offerMade,
      jobFilled,
      isUploading: false,
      uploadProgress: 0,
      pendingUpload: null,
    }));
    this.delayedClearSuccess();
    return true;
  };

  render() {
    const {
      other_user: otherUser,
      candidate_about: candidateAbout,
      job_currency_symbol: jobCurrencySymbol,
      job_title: jobTitle,
      cv_count: cvCount,
      cv,
      current_user_company_id: currentUserCompanyId,
      candidate_description: candidateDescription,
      update_status_link: updateStatusLink,
      is_employer: isEmployer,
      back_link_url: backLinkUrl,
      candidate_profile_routes: candidateProfileRoutes,
      message_tab_title: messageTabTitle,
      email_domains: emailDomains,
      application_id: applicationId,
      candidate_id: candidateId,
      show_share_button: showShareButton,
    } = this.props;

    const { other_user_name: otherUserName } = otherUser;
    const {
      status: { lastAction, jobStatus, isRejected, interviewConfirmed },
      messages,
      errors,
      success,
      actionsDropdown,
      offerMade,
      jobFilled,
      uploadProgress,
      isUploading,
    } = this.state;

    const { full_name: fullName } = candidateAbout;

    return (
      <CandidateProfileWrapper onClick={this.profileBodyClickHandle}>
        <SuccessMessage
          showMessage={success}
          clearSuccess={this.clearSuccess}
        />
        <ErrorMessage
          showError={!!errors}
          errors={errors}
          clearError={this.clearError}
        />
        <GlobalStyle />
        <ActionBar
          backLink="Candidates"
          backLinkUrl={backLinkUrl}
          title={`${fullName}, ${jobTitle}`}
          mobileTitle={fullName}
          subtitle={jobTitle}
          mobileBackButton
        />
        <CandidatePageTabNavigation
          updateStatusLink={updateStatusLink}
          updateCandidateStatus={this.updateCandidateStatus}
          toggleActionsDropdown={this.toggleActionsDropdown}
          actionsDropdown={actionsDropdown}
          isEmployer={isEmployer}
          isRejected={isRejected}
          interviewConfirmed={interviewConfirmed}
          lastAction={lastAction}
          jobCurrencySymbol={jobCurrencySymbol}
          jobStatus={jobStatus}
          candidateAbout={candidateAbout}
          cv={cv}
          cvCount={cvCount}
          otherUser={otherUser}
          candidateDescription={candidateDescription}
          offerMade={offerMade}
          jobFilled={jobFilled}
          otherUserName={otherUserName}
          messages={messages}
          userId={currentUserCompanyId}
          scrollToBottom={this.scrollToBottom}
          candidateProfileRoutes={candidateProfileRoutes}
          messageTabTitle={messageTabTitle}
          increaseApplicationCvReadCount={this.increaseApplicationCvReadCount}
          handleDownloadCv={this.handleDownloadCv}
          emailDomains={emailDomains}
          applicationId={applicationId}
          candidateId={candidateId}
          showShareButton={showShareButton}
          isUploading={isUploading}
          uploadProgress={uploadProgress}
        />
      </CandidateProfileWrapper>
    );
  }
}

CandidateProfile.propTypes = {
  cv: PropTypes.string.isRequired,
  cv_download_path: PropTypes.string.isRequired,
  candidate_description: PropTypes.string.isRequired,
  candidate_about: candidateAboutType.isRequired,
  job_currency_symbol: PropTypes.string.isRequired,
  job_title: PropTypes.string.isRequired,
  status: PropTypes.shape({
    job_status: PropTypes.string,
    last_action: PropTypes.string,
    is_rejected: PropTypes.bool,
    interview_confirmed: PropTypes.bool,
  }).isRequired,
  update_status_link: PropTypes.string.isRequired,
  other_user: otherUserType.isRequired,
  messages: PropTypes.arrayOf(messageType).isRequired,
  current_user_company_id: PropTypes.number.isRequired,
  offer_made: PropTypes.bool.isRequired,
  is_employer: PropTypes.bool.isRequired,
  back_link_url: PropTypes.string.isRequired,
  candidate_profile_routes: PropTypes.shape({
    information: PropTypes.string,
    messages: PropTypes.string,
  }).isRequired,
  message_tab_title: PropTypes.string.isRequired,
  job_filled: PropTypes.bool,
  cv_count: PropTypes.shape({
    cv_opened_count: PropTypes.number,
    cv_downloaded_count: PropTypes.number,
  }),
  application_id: PropTypes.number.isRequired,
  email_domains: PropTypes.arrayOf(PropTypes.string),
  candidate_id: PropTypes.number.isRequired,
  show_share_button: PropTypes.bool.isRequired,
};

CandidateProfile.defaultProps = {
  job_filled: PropTypes.isNull,
  cv_count: PropTypes.isNull,
  email_domains: PropTypes.isNull,
};

export default CandidateProfile;
